export class Searchquery {
    public textquery:string;
    public createdfrom: Date;
    public createdto: Date;
    public euroreferencetype: number;
    public euroreferencequery: string;
    public selectedtype: string;
    public sopyear: number;
    public eopyear:number;
    public sopmonth:number;
    public eopmonth:number;
    public mancodes: string[];
    public modid: string;
    public charid: string;
    public matrixtypeid: string;
    public glasstypeid: string;
    public glasstoptintid: string;
    public glasstintid: string;
    public bodytypeid: string;
    public glasspositionid: string;
    public actypeid:string;
    public descriptionquery:string;
    public multiquery:string;
    public language:string;
    public userid:string;
    public login:string;
    public manids: string[];
}

